import { RoutingToEpic } from './RoutingToEpic';
import { RoutingToRequestEpic } from './RoutingToRequestEpic';

export const rootRoutingEpics = [RoutingToRequestEpic, RoutingToEpic];
